document.addEventListener('DOMContentLoaded', function () {
    const leeloButton = document.getElementById('leelo-1');
    const popupLeelo = document.getElementById('popup_leelo-1');
    const popupLeelowr = document.getElementById('popup_leelowr-1');
    if (leeloButton) {
        leeloButton.addEventListener('click', function () {
            event.stopPropagation();
            popupLeelowr.classList.remove('hidden-popup-leelo');
            popupLeelowr.classList.add('visible-popup');
            document.body.style.overflowY = 'hidden';
            document.addEventListener('click', closePopupOutsideLeelo);
        });

        function closePopupOutsideLeelo(event) {
            if (!popupLeelo.contains(event.target)) {
                popupLeelowr.classList.add('hidden-popup-leelo');
                document.body.style.overflowY = 'auto';
                popupLeelowr.classList.remove('visible-popup');
                document.removeEventListener('click', closePopupOutsideLeelo); // Видаляємо обробник події
            }
        }
    }
});
document.addEventListener('DOMContentLoaded', function () {
    const leeloButton = document.getElementById('leelo-2');
    const popupLeelo = document.getElementById('popup_leelo-2');
    const popupLeelowr = document.getElementById('popup_leelowr-2');
    if (leeloButton) {
        leeloButton.addEventListener('click', function () {
            event.stopPropagation();
            popupLeelowr.classList.remove('hidden-popup-leelo');
            popupLeelowr.classList.add('visible-popup');
            document.body.style.overflowY = 'hidden';
            document.addEventListener('click', closePopupOutsideLeelo);
        });

        function closePopupOutsideLeelo(event) {
            if (!popupLeelo.contains(event.target)) {
                // Клік відбувається поза областю попапа, закриваємо його
                popupLeelowr.classList.add('hidden-popup-leelo');
                document.body.style.overflowY = 'auto';
                popupLeelowr.classList.remove('visible-popup');
                document.removeEventListener('click', closePopupOutsideLeelo); // Видаляємо обробник події
            }
        }
    }
});


document.addEventListener('DOMContentLoaded', function () {
    const leeloButtons = document.querySelectorAll('[id^="leelo-"]');
    leeloButtons.forEach(function (leeloButton) {
        leeloButton.addEventListener('click', function (event) {
            event.stopPropagation();

            const buttonId = leeloButton.id;
            const popupId = 'popup_leelowr-' + buttonId;


            const popupLeelowr = document.getElementById(popupId);

            if (popupLeelowr) {
                popupLeelowr.classList.remove('hidden-popup-leelo');
                popupLeelowr.classList.add('visible-popup');
                document.body.style.overflowY = 'hidden';

                function closePopupOutsideLeelo(event) {

                    popupLeelowr.classList.add('hidden-popup-leelo');
                    document.body.style.overflowY = 'auto';
                    popupLeelowr.classList.remove('visible-popup');
                    document.removeEventListener('click', closePopupOutsideLeelo);
                }

                popupLeelowr.addEventListener('click', closePopupOutsideLeelo);
            }
        });
    });
});

